
export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RESULTS_PER_PAGE = 10;
export const KEY = 'a118eada-608c-4c80-b537-486095bba89a';
export const MODAL_CLOSE_SEC = 2.5;